import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=c8e14f92&scoped=true&"
import script from "./OrganizationList.vue?vue&type=script&lang=js&"
export * from "./OrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganizationList.vue?vue&type=style&index=1&id=c8e14f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e14f92",
  null
  
)

export default component.exports